import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "download-forecast-modal__main-content main-content" }
const _hoisted_2 = { class: "main-content__select-responsible-user select-responsible-user" }
const _hoisted_3 = { class: "select-responsible-user__label" }
const _hoisted_4 = { class: "main-content__select-period select-period" }
const _hoisted_5 = { class: "select-period__label" }
const _hoisted_6 = { class: "select-period__content-container" }
const _hoisted_7 = { class: "select-period__content" }
const _hoisted_8 = { class: "select-period__picker-container" }

import { i18n } from '@/i18n';
import { computed, ref } from 'vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import SelectInput from '@/corePagesModule/SelectInput';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { FilterType } from '@/coreDomainsModule/entities/filter';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadForecastForReceiptModal',
  props: {
    modalState: { type: Boolean },
    selectInputIndex: { default: 1 }
  },
  emits: ["close", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

//変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

const currentFilterType = ref<FilterType | undefined>(undefined);
const startYearMonth = ref<IYearMonth>(DateService.getShiftedIYearMonthFromNowDateByMonths(0));
const selectedResponsibleUserId = ref('');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "back-button-label": _unref(t)('もどる'),
    "next-button-label": _unref(t)('ダウンロード'),
    "modal-width": 500,
    "is-disabled-next-button": !selectedResponsibleUserId.value || !startYearMonth.value.year || !startYearMonth.value.month,
    "is-disabled-scroll": true,
    onOnBack: _cache[3] || (_cache[3] = ($event: any) => (emits('close'))),
    onOnNext: _cache[4] || (_cache[4] = ($event: any) => (emits('apply', selectedResponsibleUserId.value, startYearMonth.value)))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('受領用内示ダウンロード')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('ダウンロードする受領用内示の担当者')), 1),
          _createVNode(_unref(SelectInput), {
            class: "main-content__select-input",
            index: _ctx.selectInputIndex,
            "model-value": selectedResponsibleUserId.value,
            placeholder: _unref(t)('担当者'),
            label: _unref(t)(''),
            "filter-type": 'FORECAST_FOR_RECEIPT_RESPONSIBLE_USER',
            "is-open-prop": currentFilterType.value === 'FORECAST_FOR_RECEIPT_RESPONSIBLE_USER',
            "onClick:selectInput": _cache[0] || (_cache[0] = () => (currentFilterType.value = 'FORECAST_FOR_RECEIPT_RESPONSIBLE_USER')),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (selectedResponsibleUserId.value = $event))
          }, null, 8, ["index", "model-value", "placeholder", "label", "is-open-prop"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('開始月')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(MonthPicker, {
                  class: "select-period__calendar-picker",
                  "model-value": startYearMonth.value,
                  "prop-format": _unref(t)('MonthPickerFormat'),
                  placeholder: '2024/10',
                  locale: locale.value,
                  "use-teleport": false,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (startYearMonth.value = $event))
                }, null, 8, ["model-value", "prop-format", "locale"])
              ])
            ])
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})